/* Packages */
import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';

/* Hooks */
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';
import useFlowContext from "conversie-flow-bundle/assets/js/components/flow/hooks/useFlowContext";

export default function ConversionFieldInput(props) {
    const { colClassName, field, inputType, path, id, updateValue } = props;
    const { type, label, required, disabled, placeholder = null, value, name } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    const {
        translate = () => {},
    } = useFlowContext();

    const requiredText = translate(`webstores_conversion_flow.common.required_field`);

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                {label && (
                    <div className="d-flex align-items-center justify-content-between">
                        <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                        {!required && (
                            <span className="text-muted--60 form-label__optional">optioneel</span>
                        )}
                    </div>
                )}
                {required === true && requiredText.length !== 0 &&
                    <span className="required-label">{requiredText}</span>
                }
                <Form.Control
                    className={`${error ? 'is-error' : ''}`}
                    placeholder={label}
                    name={id}
                    type={inputType}
                    {...{
                        required,
                        disabled,
                        placeholder,
                    }}
                    value={value || ''}
                    onChange={(e) => {
                        updateValue(e.target.value, () => {
                            trigger(path);
                        });
                    }}
                />
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
